import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiper = new Swiper(element.querySelector(".main_slider"), {
        modules: [Autoplay, Navigation, Pagination],
        slidesPerView: 1,
        loop: true,
        spaceBetween: 10,
        autoplay: false,
        autoHeight: true,
        navigation: {
            nextEl: element.querySelector(".swiper-button-next"),
            prevEl: element.querySelector(".swiper-button-prev"),
        },
        pagination: {
            el: element.querySelector(".swiper-pagination"),
            type: 'bullets',
            clickable: true
        }
    });
}
